'use strict';
module.exports = Object.create ? Object.create(null) : {};



//////////////////
// WEBPACK FOOTER
// ./~/react-fileupload-progress/~/core-js/internals/iterators.js
// module id = 284
// module chunks = 0